import { Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import ExcludeFromReports from 'assets/icons/settings-menu/ExcludeFromReports.inline.svg';
import ExcludeFromSpendingPlan from 'assets/icons/settings-menu/ExcludeFromSpendingPlan.inline.svg';
import classNames from 'classnames';
import QCheckbox from 'components/QCheckbox';
import * as React from 'react';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 345,
    marginTop: -9,
  },
  excludeText: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: 1.25,
  },
  imgClass: {
    marginLeft: 12,
    height: 24,
    width: 24,
  },
  unChecked: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxColumn: {
    width: 80,
    textAlign: 'center',
  },
  rows: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 7,
    paddingTop: 7,
  },
  columnWidth: {
    width: 165,
  },
  checkedColor: {
    color: theme.palette.primary.main,
  },
}));

function TransferExclusion({
  excludeReports,
  excludeF2S,
  setExcludeReports,
  setExcludeF2S,
  className,
  disabledReports,
  excludeReportsDest,
  setExcludeReportsDest,
  excludeF2SDest,
  setExcludeF2SDest,
}: {
  excludeReports?: boolean | null;
  excludeF2S?: boolean | null;
  setExcludeReports: (exclude: boolean) => void;
  setExcludeF2S: (exclude: boolean) => void;
  className?: string;
  disabledReports?: boolean;
  excludeReportsDest?: boolean;
  setExcludeReportsDest: () => void;
  excludeF2SDest?: boolean;
  setExcludeF2SDest: () => void;
}) {
  const { classes, cx } = useStyles();

  const vars = [
    {
      name: 'Spending Plan',
      image: <ExcludeFromSpendingPlan className={classes.imgClass} />,
      subText: 'Affects Spending Plan calculations.',
      checkedIn: excludeF2S,
      checkedOut: excludeF2SDest,
      onChangeIn: setExcludeF2S,
      onChangeOut: setExcludeF2SDest,
      idIn: 'ignore-spending-plan-toggle',
      idOut: 'ignore-spending-plan-toggle-out',
      disabled: false,
      divider: true,
    },
    {
      name: 'Reports',
      image: <ExcludeFromReports className={classes.imgClass} />,
      subText: 'Affects Reports, Watchlists, and Upcoming Summary.',
      checkedIn: disabledReports || excludeReports,
      checkedOut: disabledReports || excludeReportsDest,
      onChangeIn: setExcludeReports,
      onChangeOut: setExcludeReportsDest,
      idIn: 'ignore-reports-toggle',
      idOut: 'ignore-reports-toggle-out',
      disabled: disabledReports,
      divider: false,
    },
  ];

  return (
    <div className={cx(classes.column, className)}>
      <div className={classes.rows}>
        <Typography variant='paragraphRegular' className={classNames(classes.excludeText, classes.columnWidth)}>
          Exclude from:
        </Typography>
        <Typography variant='paragraphRegular' className={classes.checkboxColumn}>
          Money Out
        </Typography>
        <Typography variant='paragraphRegular' className={classes.checkboxColumn}>
          Money In
        </Typography>
      </div>
      {vars.map((item) => (
        <div key={item.idIn}>
          <div className={classes.rows}>
            <div className={classes.columnWidth}>
              <div className={classNames(classes.unChecked, item.checkedIn && item.checkedOut && classes.checkedColor)}>
                <Typography>{item.name}</Typography>
                {item.image}
              </div>
              <Typography className={classes.excludeText}>{item.subText}</Typography>
            </div>
            <div className={classes.checkboxColumn}>
              <QCheckbox disabled={item.disabled} id={item.idIn} checked={item.checkedIn} onChange={item.onChangeIn} />
            </div>
            <div className={classes.checkboxColumn}>
              <QCheckbox
                disabled={item.disabled}
                id={item.idOut}
                checked={item.checkedOut}
                onChange={item.onChangeOut}
              />
            </div>
          </div>
          {item.divider && <Divider />}
        </div>
      ))}
    </div>
  );
}

export default memo(TransferExclusion);
